import { Component } from '@angular/core';

@Component({
  selector: 'fgb-account-layout-page',
  templateUrl: './account-layout-page.component.html',
  styleUrl: './account-layout-page.component.scss',
})
export class AccountLayoutPageComponent {
  title: string = '';
}
